import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=987ec16c"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('987ec16c')) {
      api.createRecord('987ec16c', component.options)
    } else {
      api.reload('987ec16c', component.options)
    }
    module.hot.accept("./UploadImage.vue?vue&type=template&id=987ec16c", function () {
      api.rerender('987ec16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload-image/UploadImage.vue"
export default component.exports